import { useEffect, useState } from 'react';

/**
 * Two-route app, so no router dependency: History API + a popstate listener.
 * Cloudflare Pages serves index.html for unknown paths (public/_redirects),
 * which makes deep links like /article/<id> work after a hard reload.
 */
export function currentPath(): string {
  return window.location.pathname;
}

export function navigate(to: string): void {
  if (to === `${window.location.pathname}${window.location.search}`) return;
  window.history.pushState({}, '', to);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function usePath(): string {
  const [path, setPath] = useState<string>(currentPath);

  useEffect(() => {
    const onPop = () => setPath(currentPath());
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  return path;
}

export function matchArticleId(path: string): string | null {
  const match = /^\/article\/([^/]+)\/?$/.exec(path);
  return match?.[1] ? decodeURIComponent(match[1]) : null;
}
